import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { Company } from '../types/models';

const MAX_RECENTS = 8;

interface CompanyState {
  selectedCompanyId: string | null;
  companies: Company[];
  /** Most-recently-selected company IDs, newest first. Capped at
   * MAX_RECENTS — older entries fall off. Lets the picker surface
   * "the ones you keep coming back to" at the top of the list. */
  recentIds: string[];
  setCompanies: (companies: Company[]) => void;
  selectCompany: (companyId: string) => void;
}

export const useCompanyStore = create<CompanyState>()(
  persist(
    (set) => ({
      selectedCompanyId: null,
      companies: [],
      recentIds: [],
      setCompanies: (companies) =>
        set((state) => ({
          companies,
          selectedCompanyId:
            state.selectedCompanyId && companies.some((c) => c.id === state.selectedCompanyId)
              ? state.selectedCompanyId
              : companies[0]?.id ?? null,
        })),
      selectCompany: (companyId) =>
        set((state) => {
          const recents = [companyId, ...state.recentIds.filter((id) => id !== companyId)]
            .slice(0, MAX_RECENTS);
          return { selectedCompanyId: companyId, recentIds: recents };
        }),
    }),
    {
      name: 'hash_company',
    },
  ),
);
